<template>
  <section>
    <b-card
      class="py-3"
      no-body
      style="border-radius: 24px; background: #fffbff; padding-inline: 2.5rem"
    >
      <!-- navigation -->
      <div class="nav-style">
        <b-button class="pl-0" variant="link" @click="redirectBack">
          <b-icon class="font-weight-bold" icon="chevron-left"></b-icon>
        </b-button>
        &nbsp;{{ studyId }}-{{ siteId }}/Application Access Request
      </div>
      <!-- end navigation -->

      <component :is="header" :teamMembers="teamMembers"></component>

      <section v-if="!loading && allApplications.length > 0" class="mt-4">
        <application-role-recommendations
          :checkedRequests.sync="checkedRequests"
          :studyId="studyId"
          :roles="roles"
          :requestsSize="myAccessRequests.length"
          @separateApplications="separateApplications($event)"
        />
        <application-list
          v-if="recommendedApplications.length > 0"
          :applications="recommendedApplications"
          is-recommended
          @addRequest="addRequest($event)"
        >
        </application-list>
        <hr class="solid" />
        <!--        <section v-if="duplicates.length > 0" id="duplicate-section" class="text-danger">-->
        <!--          {{ duplicateMessage }}-->
        <!--          <div v-for="(item, idx) in duplicates" :key="idx">-->
        <!--            {{ idx + 1 }}) Application: <strong>{{ item.application }}</strong> - -->
        <!--            {{ item.isDeleteRequest ? 'Remove Access:' : 'Role(s):' }}-->
        <!--            <strong>{{ item.role }}</strong>-->
        <!--          </div>-->
        <!--        </section>-->
        <application-list :applications="applications" @addRequest="addRequest($event)">
          <template #heading> Applications</template>
        </application-list>
      </section>

      <section
        v-if="allApplications.length < 1 && loading"
        id="loading-spinner"
        class="py-3"
        style="border-radius: 24px; background: #fffbff; padding-inline: 2.5rem"
      >
        <div class="text-center text-secondary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </section>
    </b-card>

    <div class="sticky p-0">
      <requests-list
        v-if="!loading && allApplications.length > 0"
        :allApplications="allApplications"
        :checkedRequests="checkedRequests"
        :siteId="siteId"
        :studyId="studyId"
        @setDuplicates="duplicates = $event"
        v-on="$listeners"
        @redirectBack="redirectBack()"
      ></requests-list>
    </div>

    <b-card
      v-if="!loading && allApplications.length === 0"
      class="mt-1 p-4 text-center font-weight-bold"
      no-body
      style="border-radius: 8px; background: #ffffff"
    >
      <section class="align-content-center">
        No applications are available for this study. If you need more help, please
        <a href="/support/my-studies/contact-support-team">contact support</a>
      </section>
    </b-card>
  </section>
</template>

<script>
  import _ from 'lodash';
  import { mapGetters } from 'vuex';
  import { newStatusMap } from '../utility/CommonFunctions';
  import ApplicationRoleRecommendations from './ApplicationRoleRecommendations';
  import ApplicationList from './ApplicationList';
  import RequestsList from './RequestsList';
  import MyAccessHeader from './access-request-header/MyAccessHeader';
  import CustomAccessHeader from './access-request-header/CustomAccessHeader';
  import MyTeamHeader from './access-request-header/MyTeamHeader';

  export default {
    components: {
      ApplicationRoleRecommendations,
      ApplicationList,
      RequestsList,
      MyAccessHeader,
      CustomAccessHeader,
      MyTeamHeader,
    },
    props: {
      myAccessRequests: { type: Array, default: () => [] },
      teamMembers: Array,
      siteId: String,
      studyId: String,
      studySite: Object,
    },
    data() {
      return {
        requests: [],
        requestorPhone: '',
        options: [],
        allApplications: [],
        checkedRequests: [],
        newRequestsState: [],
        applications: [],
        recommendedApplications: [],
        defaultRequestsState: [],
        duplicates: [],
        loading: false,
        roles: null,
      };
    },
    created() {
      this.initialize();
      if (this.studySite && 'associations' in this.studySite) {
        this.roles = this.studySite['associations'];
      } else {
        this.roles = [];
      }
    },
    computed: {
      ...mapGetters(['userDetails', 'presets']),
      header() {
        if (this.$route.query.option === 'my-access') {
          return 'my-access-header';
        } else if (this.$route.query.option === 'my-team') {
          return 'my-team-header';
        } else {
          return 'custom-access-header';
        }
      },
      duplicateMessage() {
        return 'Duplicate requests found. Please review the following applications and select the correct role(s) for each application.';
      },
      isAnonymous() {
        return 'token' in this.$route.query;
      },
    },
    watch: {
      userDetails(newVal, oldValue) {
        if (newVal.selectedEmail !== oldValue.selectedEmail) {
          this.initialize();
        }
      },
    },
    methods: {
      newStatusMap,
      async initialize() {
        this.loading = true;
        this.allApplications = [];
        if (this.$route.query.option !== 'my-access') {
          await this.getMyAccessRequestTickets();
        } else {
          this.requests = this.myAccessRequests;
        }
        this.getAccessRequestApplication();
        if (this.$route.name !== 'custom-application-access' && !this.isAnonymous) {
          this.getRequestorPhone();
        }
      },
      async getMyAccessRequestTickets() {
        this.loading = true;
        this.requests = [];
        let params = {
          study_id: this.studyId,
          site_number: this.siteId,
        };
        if (this.$route.query.option === 'my-team') {
          params['person_id'] = this.userDetails.personId;
        } else if (this.isAnonymous) {
          params['email'] = this.userDetails.email;
        } else {
          params['email'] = this.userDetails.selectedEmail;
        }
        try {
          let url = `/api/get-access-requests`;
          if (this.isAnonymous) {
            url = `/api/anonymous/get-access-requests?token=${this.$route.query['token']}`;
          }
          let response = await axios.get(url, {
            params: params,
          });

          if (response.status !== 204) {
            response.data['items'].forEach(element => {
              element.childrequests.forEach(item => {
                this.requests.push(item);
              });
            });

            this.requests = this.requests.map(element => {
              if (element['systemRole'] !== null) {
                element['description'] = element['systemRole']
                  .split('-', 1)
                  .slice(1)
                  .join('-');
                element['systemRole'] = element['systemRole'].split('-', 1)[0];
              }
              let statusMap = this.newStatusMap(element.status, element.pendingReason);
              element['statusMap'] = statusMap.toUpperCase();
              return element;
            });
          }
        } catch (error) {
          console.error(error);
        }
      },
      async getAccessRequestApplication() {
        try {
          this.loading = true;
          let params = { 'next-gen': 1, studyId: this.studyId };
          let url = `/api/get-access-request-applications`;
          if (this.isAnonymous) {
            url = `/api/anonymous/get-access-request-applications?token=${this.$route.query['token']}`;
          }
          let response = await axios.get(url, {
            params: params,
          });
          if (response.status !== 204) {
            this.allApplications = response.data['items'].map(el => {
              el['systemRoles'].unshift({
                description: '',
                id: 'none',
                name: 'None (Reset)',
              });
              el['selectedRoles'] = [];
              if (!('isMultiple' in el)) {
                el['isMultiple'] = false; //TODO remove this hardcoded value when the API adds it
              }
              return el;
            });
            this.matchingApplications();
            this.createDefaultRequestsState();
            this.separateApplications('none');
          }
          this.loading = false;
        } catch (error) {
          console.error(error);
          alert(`Server is not responding, please try again later`);
          this.loading = false;
        }
      },
      matchingApplications() {
        let groupedByApp = _.groupBy(this.requests, item => item['applicationID']);
        Object.keys(groupedByApp).forEach(id => {
          groupedByApp[id].sort(function(a, b) {
            return new Date(b['createdOn']) - new Date(a['createdOn']);
          });
        });
        this.allApplications.forEach(app => {
          let foundItems = [];
          Object.keys(groupedByApp).forEach(id => {
            if (app['id'] === groupedByApp[id][0]['applicationID']) {
              foundItems.push({
                systemRole: groupedByApp[id][0].systemRole,
                systemRoleId: groupedByApp[id][0].systemRoleId,
                statusMap: groupedByApp[id][0].statusMap,
                accountStatus: groupedByApp[id][0].accountStatus,
                requestType: groupedByApp[id][0].requestType,
                deleteReason: groupedByApp[id][0].deleteReason,
              });
            }
          });
          app['matchedApplication'] = foundItems;
        });
      },
      createDefaultRequestsState() {
        this.defaultRequestsState = this.allApplications.map(application => {
          let roles = [];
          if (application['matchedApplication'].length > 0) {
            application['matchedApplication'].forEach(role => {
              let find = application['systemRoles'].find(el => el.id === role.systemRoleId);
              if (find !== undefined) {
                roles.push(find);
              }
            });
          }
          return {
            id: application['id'],
            name: application['name'],
            systemRole: roles,
          };
        });
        this.newRequestsState = JSON.parse(JSON.stringify(this.defaultRequestsState));
      },
      separateApplications(selectedRole) {
        this.applications = [];
        this.recommendedApplications = [];
        this.newRequestsState = JSON.parse(JSON.stringify(this.defaultRequestsState));
        let recommendedItem = this.presets.find(el => el.value === selectedRole);
        let copiedData = JSON.parse(JSON.stringify(this.allApplications));
        if (this.presets.length === 0) {
          this.applications = copiedData;
          return;
        }
        copiedData.forEach(item => {
          let findRecApp = recommendedItem.applications.find(app => app.id === item.id);
          if (findRecApp !== undefined) {
            findRecApp.roles.forEach(presetRole => {
              let roleSystem = item['systemRoles'].find(role => role.id === presetRole.id);
              item.selectedRoles.push(roleSystem);
            });
            this.recommendedApplications.push(item);
          } else {
            this.applications.push(item);
          }
        });
        if (recommendedItem.value === 'none' || recommendedItem.applications.length === 0) {
          this.checkedRequests = [];
        }
      },
      addRequest(event) {
        let index = this.newRequestsState.findIndex(element => element.id === event.id);
        let emptyArray = [];
        this.newRequestsState[index]['systemRole'] = emptyArray.concat(event.systemRole);
        this.newRequestsState[index]['type'] = event.type;
        this.checkedRequests = [];
        this.defaultRequestsState.forEach(element => {
          let foundRequest = this.newRequestsState.find(req => req.id === element.id);
          if (element.systemRole.length === foundRequest.systemRole.length) {
            foundRequest.systemRole.forEach(role => {
              if (!element.systemRole.some(el => el.id === role.id)) {
                this.checkedRequests.push(foundRequest);
                //TODO: we may need to add "return" in this line
              }
            });
          } else {
            if (foundRequest.systemRole.length !== 0) {
              this.checkedRequests.push(foundRequest);
            }
          }
        });
        this.checkIsDirty(event);
      },
      checkIsDirty(event) {
        let appComponent = document.getElementById(event.id);
        if (
          this.checkedRequests.findIndex(element => element.id === event.id) > -1 &&
          appComponent !== null
        ) {
          appComponent.dispatchEvent(new Event('addIsDirty'));
        } else if (appComponent !== null) {
          appComponent.dispatchEvent(new Event('removeIsDirty'));
        }
      },
      async getRequestorPhone() {
        try {
          let url = `/api/get-requestor-phone`;
          if (this.isAnonymous) {
            url = `/api/anonymous/get-requestor-phone?token=${this.$route.query['token']}`;
          }
          let response = await axios.get(url, {
            params: {
              email: this.userDetails.selectedEmail,
            },
          });
          this.requestorPhone = response.status !== 204 ? response.data['items'][0] : '';
          let data = {
            key: 'phoneNumber',
            value: this.requestorPhone,
          };
          this.$store.commit('updateUser', data);
        } catch (e) {
          console.error(e);
        }
      },
      redirectBack() {
        if (this.$route.name === 'application-access-manager-create-request') {
          this.$router.push({
            name: 'application-access-manager-select-study-site',
            params: { user: this.$route.params.user },
          });
        } else if (this.isAnonymous) {
          this.$router.push({
            name: 'anonymous-form-select-study-site',
            query: {
              expires: this.$route.query['expires'],
              token: this.$route.query['token'],
              signature: this.$route.query['signature'],
            },
          });
        } else {
          this.$emit('hideManageRequest');
        }
      },
    },
  };
</script>

<style>
  .nav-style {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #005db8;
  }
</style>
